import type {
  ProjectProfitAndRevenueSummaryQuery,
  ProjectProfitAndRevenueTableDataQuery,
} from "@src/__generated__/urql-graphql";
import { action, makeObservable, observable } from "mobx";
import { createContext, useContext } from "react";
import { ProjectReportStore } from "../../common/store";
import { ProjectProfitAndRevenueModel } from "../models";

export const StoreContext = createContext({} as Store);
export const useStore = () => useContext(StoreContext);

export class Store {
  readonly key = "projectRevenueAndProfit";
  reportStore: ProjectReportStore;
  @observable projects: ProjectProfitAndRevenueModel[] = [];
  @observable
  summary?: ProjectProfitAndRevenueSummaryQuery["projectRevenueSummary"];

  constructor() {
    makeObservable(this);
    this.reportStore = new ProjectReportStore(this.key);
  }

  @action setTableData(query: ProjectProfitAndRevenueTableDataQuery) {
    this.projects = (query.projectRevenue.projects ?? []).map(
      (i) => new ProjectProfitAndRevenueModel(i),
    );
    this.reportStore.setExpenseBudgetCategories(
      query.expenseBudgetCategories ?? [],
    );

    if (query.projectRevenue.projects) {
      this.reportStore.pagination.setFromPaginatorInfo(
        query.projectRevenue.paginatorInfo,
      );
    }
  }

  @action setSummary(query: ProjectProfitAndRevenueSummaryQuery) {
    this.summary = query.projectRevenueSummary;
  }
}
